import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { CompanySwitcher, UserProfileMenu } from '@crm/features';
import HomeIcon from '@crm/shared/assets/icons/home.svg?react';
import MainLogo from '@crm/shared/assets/icons/main-logo.svg?react';
import { ROUTES } from '@crm/shared/routes';

export const AppHeader = () => {
    const { t } = useTranslation();

    return (
        <header className="flex shrink-0 items-center justify-between border-b border-gray-200 pr-3">
            <div className="flex items-center justify-center pr-1">
                <Link
                    to={ROUTES.HOME}
                    aria-label={t('crm.appMenu.homeAriaLabel')}
                    className="group flex h-[46px] w-[49px] py-1 pt-[7px] pr-[5px] pl-[14px] hover:flex hover:items-center hover:justify-center hover:bg-smtr-main-gray-100 hover:p-0 hover:pl-[5px]"
                >
                    <span className="flex size-7.5 shrink-0 items-center justify-center">
                        <MainLogo className="size-7.5 text-black group-hover:hidden" />
                        <HomeIcon className="hidden size-6 text-smtr-main-black-100 group-hover:block" />
                    </span>
                </Link>
                <CompanySwitcher />
            </div>
            <div>
                <UserProfileMenu />
            </div>
        </header>
    );
};
